import { render, staticRenderFns } from "./MigrarContratoForm.vue?vue&type=template&id=46d04796"
import script from "./MigrarContratoForm.vue?vue&type=script&lang=js"
export * from "./MigrarContratoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports